import {pxToRem} from '../../../utills/pxToRem'
import colors from '../../foundations/colors'

// Outer wrapper: full height so inner can align to bottom of header row
const iconWrapperStyle = {
    display: {base: 'inline-flex', md: 'flex', lg: 'flex'},
    alignItems: 'center',
    justifyContent: 'center',
    height: {base: 'auto', md: '100%', lg: '100%'},
    alignSelf: {md: 'stretch', lg: 'stretch'},
    minHeight: {md: '100%', lg: '100%'}
}

// Inner: only icon width, white underbar + hover at bottom of header (like mega-menu level 1). Desktop only.
const iconInnerStyle = {
    display: {base: 'inline-flex', md: 'flex', lg: 'flex'},
    alignItems: 'center',
    justifyContent: 'center',
    width: {base: 'auto', md: 'fit-content', lg: 'fit-content'},
    minWidth: {base: 'auto', md: 0, lg: 0},
    height: {base: 'auto', md: '100%', lg: '100%'},
    minHeight: {md: '100%', lg: '100%'},
    borderBottom: {
        base: 'none',
        sm: 'none',
        md: `${pxToRem(5)} solid transparent`,
        lg: `${pxToRem(5)} solid transparent`
    },
    _hover: {
        borderBottomColor: {base: 'transparent', sm: 'transparent', md: 'white', lg: 'white'},
        backgroundColor: {
            base: 'transparent',
            sm: 'transparent',
            md: colors.cav_header_hover,
            lg: colors.cav_header_hover
        }
    },
    _focusWithin: {
        borderBottomColor: {base: 'transparent', sm: 'transparent', md: 'white', lg: 'white'},
        backgroundColor: {
            base: 'transparent',
            sm: 'transparent',
            md: colors.cav_header_hover,
            lg: colors.cav_header_hover
        }
    }
}

export default {
    baseStyle: {
        container: {
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            minWidth: 'xs',
            width: 'full',
            backgroundColor: 'cav_header_bg',
            boxShadow: `0 ${pxToRem(2)} ${pxToRem(4)} 0 rgba(0, 0, 0, 0.25)`,
            backdropFilter: `blur(${pxToRem(10)})`,
            fontSize: pxToRem(28),
            color: 'white'
        },
        content: {
            width: '100%',
            maxWidth: '100%',
            minHeight: ['auto', 'auto', pxToRem(80), pxToRem(80)],
            height: ['auto', 'auto', pxToRem(80), pxToRem(80)],
            paddingTop: [pxToRem(3), pxToRem(6), 0, 0],
            paddingBottom: [pxToRem(3), pxToRem(6), 0, 0],
            paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)],
            paddingRight: [pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)]
        },
        searchContainer: {
            order: [2, 2, 2, 'inherit'],
            width: ['full', 'full', pxToRem(153), pxToRem(153)],
            maxWidth: ['none', 'none', pxToRem(153), pxToRem(153)],
            marginRight: [0, 0, 0, 0],
            marginBottom: [0, 0, 0, 0]
        },
        bodyContainer: {
            marginLeft: [2, 2, 0, 0],
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        },
        logo: {
            height: [5, 5, 8, 8],
            width: [pxToRem(94), pxToRem(94), pxToRem(148), pxToRem(148)]
        },
        logoIcon: {
            height: '100%'
        },
        icons: {
            width: ['auto', 'auto', 'auto', 'auto'],
            color: 'white',
            img: {objectFit: 'contain', maxWidth: '100%', maxHeight: '100%'}
        },
        hamburgerIcon: {
            width: [5, 5, 10, 10],
            height: [5, 5, 8, 8]
        },
        storeLocatorIcon: {
            marginLeft: [0, 0, pxToRem(12), pxToRem(12)],
            width: ['auto', 'auto', pxToRem(22.239), pxToRem(22.239)],
            height: [pxToRem(20), pxToRem(20), pxToRem(27), pxToRem(27)],
            img: {
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: [pxToRem(20), pxToRem(20), pxToRem(27), pxToRem(27)]
            }
        },
        accountIcon: {
            width: ['auto', 'auto', 'auto', 'auto'],
            height: [pxToRem(20), pxToRem(20), 'auto', 'auto'],
            img: {
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: [pxToRem(20), pxToRem(20), pxToRem(30), pxToRem(30)]
            }
        },
        iconWrapper: iconWrapperStyle,
        iconInner: iconInnerStyle,
        cartIcon: {
            width: ['auto', 'auto', pxToRem(40.5), pxToRem(40.5)],
            height: [pxToRem(20), pxToRem(20), pxToRem(30), pxToRem(30)],
            img: {objectFit: 'contain', maxWidth: '100%', maxHeight: '100%'}
        },
        backetIcon: {
            marginRight: pxToRem(16)
        },
        account: {
            height: 11,
            minWidth: 'auto',
            cursor: 'pointer',
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            }
        },
        arrowDown: {
            height: 11,
            minWidth: 'auto',
            marginRight: 0,
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            cursor: 'pointer',
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            },
            display: ['none', 'none', 'none', 'block']
        },
        signout: {
            width: '100%',
            borderRadius: pxToRem(4),
            height: pxToRem(44),
            padding: pxToRem(16),
            py: pxToRem(12),
            marginTop: pxToRem(4),
            _hover: {
                background: 'gray.50'
            }
        },
        signoutText: {
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        signoutIcon: {
            marginRight: pxToRem(8)
        }
    },
    parts: [
        'container',
        'content',
        'searchContainer',
        'bodyContainer',
        'logo',
        'logoIcon',
        'icons',
        'iconWrapper',
        'iconInner',
        'accountIcon',
        'storeLocatorIcon',
        'cartIcon',
        'basket',
        'hamburgerIcon',
        'signout'
    ]
}
